<template>
  <el-dialog
    :visible.sync="chatDialogVisible"
    custom-class="chat-dialog-with-employee"
    :before-close="handleClose"
  >
    <div slot="title">
      <img class="chat-title__avatar" @click="showCard(receiver)" :src="receiver.avatar || defImage('actor')"/>
      <span class="chat-title__name">{{ receiver.name }}</span>
      <span class="chat-title__name">{{ receiver.position }}</span>
      <button type="button" class="el-dialog__headerbtn">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <div v-if="imInfoCard" class="imInfoCard">
        <p class="text-right"><i @click="closeCard" class="el-icon-close"></i></p>
        <img  class="chat-title__avatar1" :src="imInfo.headImage || defImage('actor')" />
        <p class="font-size-16 p1 word-Wrap">{{ imInfo.name}}</p>
        <p class="font-size-14 p1 word-Wrap">{{ imInfo.post}}</p>
        <p class="font-size-12 p2 word-Wrap">{{ imInfo.corporateName}}</p>
        <p class="font-size-12 p2 word-Wrap">{{ imInfo.countryName}}</p>
      </div>
    </div>

    <ChatDialog />
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import ChatDialog from '@/components/chat/ChatDialog'
import { getUserInfoByEasemob } from '@/api/index'

export default {
  name: 'ChatWithEmployee',

  components: {
    ChatDialog
  },

  data() {
    return {
      imInfoCard:false,
      imInfo:{},
    }
  },

  computed: {
    ...mapState(['chatDialogVisible', 'receiver'])
  },

  mounted() {},

  methods: {
    showCard(item){
      let params = {
        easemobAccount: item.easemobAccount,
        languageType: this.language == 'en' ? 'EN' : 'CN'
      }
      getUserInfoByEasemob(params).then((res)=>{
        this.imInfo = res.data.data
        this.imInfoCard = true
      })
    },
    handleClose() {
      this.$store.commit('setReceiver', '')
      this.$store.commit('toogleChatDialog')
      this.imInfoCard = false
    },
    closeCard() {
      this.imInfoCard = false
    },
  }
}
</script>
<style lang="stylus">
.chat-dialog-with-employee
  width 700px

  .el-dialog__header
    background-color $color-main
    padding 6px 20px
    box-sizing border-box

  .el-dialog__body
    padding 0

  .el-dialog__title
    color $color-white
    font-size 16px
    line-height 30px

  .el-dialog__headerbtn
    top 13px

  .el-dialog__close
    color $color-white

  .chat-title__icon
    color $color-white
    margin-right 10px
    cursor pointer

  .chat-title__name
    color $color-white
    margin-right 10px
    font-size 14px
    line-height 30px

  .chat-title__avatar
    width 30px
    height 30px
    border-radius 50%

    margin-right 10px
.imInfoCard{
  position: absolute;
  width: 240px;
  top: 52px;
  left: 4px;
  z-index: 10;
  background: $color-white;
  border-radius: 5px;
  line-height: 30px;
  padding: 4px 10px 10px 10px;
  text-align: center;
  box-shadow:0 0 10px $color-black-10;
  .chat-title__avatar1 {
    width: 64px;
    height: 64px;
    border-radius: 50%;
  }
  .p1{
    color $color-black-65  
  }
  .p2{
    color $color-black-45  
  }
}
</style>
